import { z } from 'zod';

export const EditUsernameSchema = z.object({
  username: z.string().min(1)
});

export type EditUsernameFormValues = z.infer<typeof EditUsernameSchema>;
